import React, { createContext, useContext, useEffect, useState } from "react";
import { supabaseA, supabaseAdmin } from "./supabaseClient";
import { logsTableName, noShowTableName, tableName } from "./env";
import { copyItems, deleteItemsByDate, logEvent } from "../utils/utils";

// const TimerContext = createContext();

export const TimerProvider = ({ children, resetTime }) => {
  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    const d = `${year}-${month}-${day}`;
    // const d = `${2025}-${1}-${1}`;
    const tD = JSON.parse(localStorage.getItem("date"));

    console.log("🕒 Date Check:");
    console.log("   Current date (d):", d);
    console.log("   Stored date (tD):", tD);
    console.log("   tD exists?", Boolean(tD));
    console.log("   Dates different?", d !== tD);

    // Run if there's no stored date OR if the date is different
    if (!tD || (tD && d !== tD)) {
      console.log("✨ Calling deleteItemsByDate with resetTime:", resetTime);
      // Fire-and-forget maintenance job. It no-ops for read-only patients; the
      // .catch keeps any unexpected rejection from surfacing as an uncaught error.
      deleteItemsByDate(resetTime).catch((e) =>
        console.warn("daily cleanup skipped:", e?.message || e),
      );
    } else {
      console.log(
        "❌ Not calling deleteItemsByDate because: same date as stored"
      );
    }

    console.log("💾 Setting new date in localStorage:", d);
    localStorage.setItem("date", JSON.stringify(d));
  }, []);
  // const [loading, setLoading] = useState(false);
  // const [duplicatesTrackingResult, setDuplicatesTrackingResult] =
  //   useState(null);
  // const [duplicateRecordsResult, setDuplicateRecordsResult] = useState(null);
  // const [noShowsResult, setNoShowsResult] = useState(null);

  // useEffect(() => {
  //   const runSupabaseFunctions = async () => {
  //     setLoading(true);

  //     // 1. Call rebuild_duplicates_tracking
  //     const { data: dataRebuild, error: errorRebuild } =
  //       await supabaseAdmin.rpc("rebuild_duplicates_trackings");
  //     if (errorRebuild) {
  //       console.error("Error in rebuild_duplicates_tracking:", errorRebuild);
  //     }
  //     setDuplicatesTrackingResult(dataRebuild);

  //     // 2. Call process_duplicate_records
  //     const { data: dataDuplicates, error: errorDuplicates } =
  //       await supabaseAdmin.rpc("process_duplicate_recordss");
  //     if (errorDuplicates) {
  //       console.error("Error in process_duplicate_records:", errorDuplicates);
  //     }
  //     setDuplicateRecordsResult(dataDuplicates);

  //     // 3. Call process_no_shows_new
  //     const { data: dataNoShows, error: errorNoShows } =
  //       await supabaseAdmin.rpc("process_no_showss");
  //     if (errorNoShows) {
  //       console.error("Error in process_no_shows_new:", errorNoShows);
  //     }
  //     setNoShowsResult(dataNoShows);

  //     setLoading(false);
  //   };

  //   // Run the functions on component mount
  //   runSupabaseFunctions();

  return <>{children}</>;
};

// export const useTimer = () => useContext(TimerContext);
